function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#596266",
  d: "M5.17157288,4.82842712 L5.87867966,5.53553391 C5.33578644,6.07842712 5,6.82842712 5,7.65685425 C5,8.48528137 5.33578644,9.23528137 5.87867966,9.77817459 L5.17157288,10.4852814 C4.44771525,9.76142375 4,8.76142375 4,7.65685425 C4,6.55228475 4.44771525,5.55228475 5.17157288,4.82842712 Z M10.8284271,4.82842712 C11.5522847,5.55228475 12,6.55228475 12,7.65685425 C12,8.76142375 11.5522847,9.76142375 10.8284271,10.4852814 L10.1213203,9.77817459 C10.6642136,9.23528137 11,8.48528137 11,7.65685425 C11,6.82842712 10.6642136,6.07842712 10.1213203,5.53553391 L10.8284271,4.82842712 Z M8,9.65685425 C6.8954305,9.65685425 6,8.76142375 6,7.65685425 C6,6.55228475 6.8954305,5.65685425 8,5.65685425 C9.1045695,5.65685425 10,6.55228475 10,7.65685425 C10,8.76142375 9.1045695,9.65685425 8,9.65685425 Z"
});

var SvgStage2 = function SvgStage2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStage2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Stage2.b8f4bd32.svg";
export { ForwardRef as ReactComponent };